module.exports = __webpack_public_path__ + "img/africa-lg.ee6729ba.svg";